import React from 'react';
// tr
import i18n from '../../i18n';
// context
import { AppDataContext } from '../../context/Context';
import Autocomplete from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';
import { Box, TextField, Typography } from '@mui/material';
import { getExtractValue } from '../../utils/formatName';
// @mui

export default class DialogSelectField extends React.Component {
    static contextType = AppDataContext;
    handleChanged = (field, value) => {
        if (value === null) {
            this.props.onChange(field, null);
        } else {
            this.props.onChange(field, value.id);
        }
    };
    render() {
        // field, value, cache, onChange

        const translatedName = i18n.t(`columns.${this.props.field.label}`);
        const { value, field } = this.props;

        const show = field.show;
        const translate = field.translate || null;
        const nestedObject = field.nestedObject;
        const secondaryObject = field.secondaryObject || null;
        const items = this.context.getState().controllersData[field.from] || [];

        const mappedItems = items.map((item) => {
            const val = getExtractValue(
                item,
                show,
                nestedObject,
                secondaryObject
            );
            const translatedValue = translate
                ? i18n.t(`${translate}.${val}`)
                : val;
            return {
                id: item.id,
                value: translatedValue
            };
        });

        const onlyRead = !!field.onlyRead;
        // displayOnEditForReadOnly
        const readOnEdit = this.props.field.displayOnEditForReadOnly;
        const mode = this.props.mode; // 'add' | 'edit'
        if (readOnEdit && mode === 'edit') {
            const valueItem = mappedItems.find(
                (item) => item.id === value
            )?.value;
            return (
                <Box display="flex" gap={1} alignItems="center">
                    <Typography variant="body2" color="textSecondary">
                        {translatedName}:
                    </Typography>
                    {valueItem ? (
                        <Typography variant="body1" color="textPrimary">
                            {valueItem}
                        </Typography>
                    ) : (
                        <Typography variant="body2" color="textSecondary">
                            {i18n.t('common.notSet')}
                        </Typography>
                    )}
                </Box>
            );
        }
        const disabledByTemplate = !!field.disabledByTemplate;
        const disabledExplicit = !!this.props.field.disabled;
        const disabledFromProps = !!this.props.disabled;
        const isDisabled = Boolean(
            onlyRead || disabledExplicit || disabledByTemplate || disabledFromProps || onlyRead
        );

        return (
            <FormControl fullWidth sx={{ mt: 1 }}>
                <Autocomplete
                    value={
                        mappedItems.find((item) => item.id === value) || null
                    }
                    onChange={(event, newValue) => {
                        this.handleChanged(field.id, newValue);
                    }}
                    options={mappedItems}
                    getOptionLabel={(option) => option.value}
                    renderOption={(props, option) => (
                        <li {...props} key={option.id}>
                            {option.value}
                        </li>
                    )}
                    isOptionEqualToValue={(option, val) => option.id === val.id}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={translatedName}
                            variant="outlined"
                            helperText={
                                field.helperText ? i18n.t(`helperTexts.${field.helperText}`) : ''
                            }
                        />
                    )}

                    disabled={isDisabled}
                />
            </FormControl>
        );
    }
}
